var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeCurrencyUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M10 0l10 9h-3v8H3V9H0l10-9zM7.22 5.93c-.47.47-.72 1.1-.72 1.82 0 1.68 2.04 2.32 3.26 2.71 1.5.47 1.71.75 1.74.79 0 .75-1.35.75-1.5.75-.63 0-.97-.12-1.14-.22-.19-.11-.36-.28-.36-.78h-2c0 1.43.74 2.16 1.35 2.5.33.2.72.34 1.15.42V15h2v-1.09c1.53-.3 2.5-1.29 2.5-2.66 0-1.58-1.62-2.22-3.14-2.7-1.56-.49-1.83-.78-1.86-.8 0-.25.07-.34.14-.41C8.85 7.13 9.36 7 10 7c.68 0 1.5.13 1.5.75h2c0-1.41-.94-2.38-2.5-2.66V4H9v1.08c-.74.13-1.35.42-1.78.85z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCurrencyUsd);
export default __webpack_public_path__ + "static/media/home-currency-usd.159705d00cbfbcca1bd9892a098c6153.svg";
export { ForwardRef as ReactComponent };